import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useEmbeddedEffect } from '@machinemetrics/mm-react-embeddable';
import i18n from 'i18next';

import { actionCloseShiftIntro } from 'lib/actions';
import { getShiftIntroOpen } from 'lib/selectors/getShiftIntroOpen';
import { SHIFT_HANDOVER_HOST } from 'lib/appConfig';
import { getCurrentOperator } from 'lib/selectors/getCurrentOperator';
import { getMachine } from 'lib/selectors/getMachine';
import Routes from 'lib/utils/routes';
import MMEmbeddableZoneWithLoader from 'components/MMEmbeddableZoneWithLoader';
import MMDrawer from 'components/MMDrawer';

const EmbeddedShiftIntro = ({ id, operator }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const machine = useSelector(getMachine);
  const [path, setPath] = useState('/intro');

  useEmbeddedEffect(id, 'shift-intro:close', () => {
    dispatch(actionCloseShiftIntro());
    // Navigate to select job after closing intro
    if (machine?.id) {
      history.push(Routes.machineIdSelectJobPath(machine.id));
    }
  });

  useEmbeddedEffect(id, 'shift-intro:setPath', (data) => {
    if (data?.path) {
      setPath(data.path);
    }
  });

  const context = {
    operatorId: operator?.id,
    operatorErpId: operator?.erpId,
    operatorName: operator?.name,
  };

  return (
    <MMEmbeddableZoneWithLoader
      id={id}
      src={`${SHIFT_HANDOVER_HOST}`}
      path={path}
      context={context}
      params={{
        language: i18n.language,
      }}
    />
  );
};

export const ShiftIntroWrapper = () => {
  const id = 'shift-intro-screen';
  const dispatch = useDispatch();
  const shiftIntroOpen = useSelector(getShiftIntroOpen);
  const currentOperator = useSelector(getCurrentOperator);

  const operator = {
    id: currentOperator?.id,
    erpId: currentOperator?.erpId,
    name: currentOperator?.name,
  };

  return (
    <MMDrawer
      isOpen={shiftIntroOpen}
      onClose={() => {
        dispatch(actionCloseShiftIntro());
      }}
      title="Hello Operator!"
    >
      <EmbeddedShiftIntro id={id} operator={operator} />
    </MMDrawer>
  );
};
